var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 45L22.5 42.5M22.5 42.5L7.5 50V17.5L22.5 10M22.5 42.5V10M22.5 10L37.5 17.5M37.5 17.5L52.5 10V30M37.5 17.5V30M50.5 50.5L55 55M37.5 45C37.5 46.9891 38.2902 48.8968 39.6967 50.3033C41.1032 51.7098 43.0109 52.5 45 52.5C46.9891 52.5 48.8968 51.7098 50.3033 50.3033C51.7098 48.8968 52.5 46.9891 52.5 45C52.5 43.0109 51.7098 41.1032 50.3033 39.6967C48.8968 38.2902 46.9891 37.5 45 37.5C43.0109 37.5 41.1032 38.2902 39.6967 39.6967C38.2902 41.1032 37.5 43.0109 37.5 45Z",
    stroke: "#1E3F76",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapSearch);
export default __webpack_public_path__ + "static/media/map-search.22ff7f49e1a5f4d9b651c8290c240845.svg";
export { ForwardRef as ReactComponent };